<template>
  <div v-if="isEditionVisible">
    <div
      class="lg:hidden flex flex-row items-center justify-between gap-[10px] w-full h-[40px] px-5 text-xs edition-upgrade-tag trail"
    >
      <span
        v-if="currentEditionPopoverType === PopoverType.SINGLE_AIR_TRIAL"
        v-html="t('editionTag.trial', { days: format(singleAirTrialLeftDays) })"
      >
      </span>
      <span v-else-if="currentEditionPopoverType === PopoverType.MULTI">
        {{ t('editionTag.expire') }}
      </span>
      <span v-else>{{ t('editionTag.freemium') }}</span>
      <button
        class="edition-upgrade-btn text-xs th-btn py-[2px] pl-[4px] pr-[8px] bg-white/80 text-[#0764e9] active:!bg-white active:!shadow-none"
        @click="handleShowPremium"
      >
        <PtIcon :icon="UpgradeIcon" class="th-btn-icon text-xl" />
        {{ t('editionTag.upgrade') }}
      </button>
    </div>
    <div v-if="showPremium" class="edition-upgrade-wrap lg:!hidden" @click="showPremium = false">
      <div
        data-theme="patsnapRD"
        class="w-[300px] bg-white px-4 pb-6 shadow-[0_0_12px_rgba(0,0,0,0.12)] rounded-t-[20px]"
        @click.stop
      >
        <div class="mt-[-28px] -mx-4">
          <img :src="trail2upgrade" alt="" />
        </div>
        <template
          v-if="
            currentEditionPopoverType === PopoverType.SINGLE ||
            currentEditionPopoverType === PopoverType.SINGLE_AIR_TRIAL
          "
        >
          <div>
            <h3 class="text-[24px] font-bold mb-1 mt-3 text-eureka-600 leading-[32px]">
              {{ t('packageDiff.singleAirUpgrade.title') }}
            </h3>
            <p class="text-sm text-gray-90">{{ t('packageDiff.singleAirUpgrade.description') }}</p>
          </div>
          <ul
            class="flex flex-col gap-2 rounded-lg bg-gradient-to-b from-[#EDF4FC] to-[rgba(237,244,252,0.4)] p-3 my-2"
          >
            <li
              v-for="(feature, key) in tm('packageDiff.singleAirUpgrade.features')"
              :key="key"
              class="flex text-sm text-grey-450 gap-1"
            >
              <PtIcon
                icon="SolidTickCircle"
                class="th-btn-icon text-xl fill-eureka-500 flex-shrink-0"
              />
              <span v-html="feature" />
            </li>
          </ul>
          <button class="th-btn w-full th-btn-primary" @click="handleUpgrade">
            {{ t('packageDiff.singleAirUpgrade.buttonText') }}
          </button>
        </template>
        <template v-else>
          <div>
            <h3 class="text-[24px] font-bold mb-1 mt-3 text-eureka-600 leading-[32px]">
              {{ t('packageDiff.muti.title') }}
            </h3>
            <p class="text-sm text-gray-90">{{ t('packageDiff.muti.description') }}</p>
          </div>
          <ul
            class="flex flex-col gap-2 rounded-lg bg-gradient-to-b from-[#EDF4FC] to-[rgba(237,244,252,0.4)] p-3 my-2"
          >
            <li
              v-for="pkg in trialPackages"
              :key="pkg.eureka_package"
              class="flex items-center text-sm text-grey-450 gap-1"
            >
              <div class="flex-shrink-0 inline-block w-2 h-2 mr-1 bg-eureka-600 rounded-full"></div>
              <span
                v-html="
                  t('packageDiff.muti.expire', {
                    package: t(`commonProductPackage.${pkg.eureka_package}`),
                    days: transformLeftDays(pkg.trial_package_left_days || 0),
                  })
                "
              >
              </span>
            </li>
          </ul>
          <button class="th-btn w-full th-btn-primary" @click="handleUpgrade">
            {{ t('packageDiff.muti.buttonText') }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { PtIcon } from 'patsnap-biz';
import { useI18n } from 'vue-i18n';
import { format } from '@eureka/utils/number-format';
import { cn, en, jp, tw } from '../../infrastructure/locales';
import UpgradeIcon from '../../assets/icon/upgrade.svg';
import trail2upgrade from '../../assets/img/trail2upgrade.png';
import '@patsnap-ui/icon/assets/solid/TickCircle.svg';
import { useEditionTag } from '../../composables/use-edition-tag';
import { useEditionVisibilityWithRouteMeta } from '../../composables/use-edition-visibility-with-route-meta';
import commonProductPackageMessage from '@eureka/language-tool/locales/common-product/package';
import _ from 'lodash';

const props = defineProps<{
  isLogin: boolean;
}>();

const { t, tm } = useI18n({
  messages: _.merge(
    {
      cn,
      en,
      jp,
      tw,
    },
    commonProductPackageMessage,
  ),
});

const {
  currentEditionPopoverType,
  singleAirTrialLeftDays,
  transformLeftDays,
  isEditionVisible: baseVisibility,
  trialPackages,
  handleUpgrade: _handleUpgrade,
  PopoverType,
} = useEditionTag(props);

const { isEditionVisible } = useEditionVisibilityWithRouteMeta(baseVisibility);

const showPremium = ref(false);

function handleShowPremium() {
  showPremium.value = true;
}

function handleUpgrade() {
  showPremium.value = false;
  _handleUpgrade();
}
</script>
